(function($) {
    $(document).ready(function() {
        $("select").each(function(index) {
            if ($(this).hasClass('country_select') == true || $(this).hasClass('state_select') == true) {
                return;
            }
            $(this).selectric({
                openOnFocus: false,
                disableOnMobile: false,
                nativeOnMobile: false
            });
        });

        $('.woocommerce-account .woocommerce-MyAccount-content form select').selectric({
            openOnFocus: false,
            disableOnMobile: false,
            nativeOnMobile: false
        });

        $(".navbar-toggler").click(function() {
            $(".site-header").toggleClass('menu_active');
            $("body").toggleClass('toggle_menu_active');
            if ($('#main-nav li.menu-item-has-children').hasClass("open")) {
                $('#main-nav li.menu-item-has-children button.submenu-toggle').removeClass("active");
                $('#main-nav li.menu-item-has-children').removeClass("open");
                $('#main-nav li.menu-item-has-children .dropdown-menu').slideUp();
            }
        });

        $('#main-nav').find('li.menu-item-has-children > a').after('<button class="submenu-toggle"><svg xmlns="http://www.w3.org/2000/svg" width="12.257" height="6.928" viewBox="0 0 12.257 6.928"><path id="Icon_feather-chevron-down" data-name="Icon feather-chevron-down" d="M0,0,5,5l5-5" transform="translate(1.131 1.131)" fill="none" stroke="#101820" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"/></svg></button>');
        $('body').on('click', '#main-nav button.submenu-toggle', function() {
            $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
            $(this).parent().siblings().find('button.submenu-toggle').next().slideUp().parent().removeClass('open');
            $(this).toggleClass('active').next().slideToggle().parent().toggleClass('open');
        });

        $(".header_account").hover(function() {
            $(".header_account .header_account_dropdown").fadeToggle();
        });

        $(".validation_message").attr("role", "alert");

        $(document).ajaxComplete(function() {
            $("select").each(function(index) {
                if ($(this).hasClass('country_select') == true || $(this).hasClass('state_select') == true) {
                    return;
                }
                $(this).selectric('refresh');
            });
        });

        $(document).on('gform_page_loaded', function(event, form_id, current_page) {
            $(".validation_message").attr("role", "alert");
            $("select").each(function(index) {
                if ($(this).hasClass('country_select') == true || $(this).hasClass('state_select') == true) {
                    return;
                }
                $(this).selectric('refresh');
            });
        });

        $(".product_category_slider_sec").each(function(index) {
            let slide = $(this).find('.product_cat_list__item');
            let slider = $(this).find('.product_cat_list');
            if ($(slide).length > 1) {
                $(slider).slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    prevArrow: $(this).find('.previous_button'),
                    nextArrow: $(this).find('.next_button'),
                    dots: false,
                    variableWidth: true,
                    responsive: [{
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ]
                });
            }
        });
        offsetLeft();
        equalheight('.product_cat_list__item__inner .image');
        equalheight('.product_cat_list__item__inner .cat_name');
        equalheight('.product_cat_list__item__inner .tagline');
    });
    $("body").on("change", ".product .loop_add_to_cart > .quantity > .qty", function() {
        let qt = $(this).val();
        $(this).parent().next().find('.add_to_cart_button').attr('data-quantity', qt);
    });
})(jQuery);

jQuery(window).resize(function(jQuery) {
    offsetLeft();
    equalheight('.product_cat_list__item__inner .image');
    equalheight('.product_cat_list__item__inner .cat_name');
    equalheight('.product_cat_list__item__inner .tagline');
});


function offsetLeft() {
    if ((jQuery('.product_category_slider_sec .product_cat_list__main').length > 0)) {
        var applicationsoffset = jQuery('.product_category_slider_sec .product_cat_list__main').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.product_category_slider_sec .product_cat_list__main').css('width', (applicationswindWidth - applicationsoffset.left));
    }
}

function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function() {

        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

function changeQty(item) {
    jQuery(item).closest('.quantity').find('.qty').trigger('change');
}